"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInterfaceScale = exports.getInterfaceRect = exports.getInterfaceScale = exports.normalizeInterfaceScale = void 0;
var CONSTANTS_1 = require("./CONSTANTS");
var mediaQueries = new Map();
var cssScale = 1;
var normalizeInterfaceScale = function (value) { return (CONSTANTS_1.INTERFACE_SCALES.includes(value) ? value : 100); };
exports.normalizeInterfaceScale = normalizeInterfaceScale;
var getInterfaceScale = function () { return cssScale; };
exports.getInterfaceScale = getInterfaceScale;
// Pointer coordinates include CSS zoom; positioned UI uses unzoomed CSS pixels.
var getInterfaceRect = function (element) {
    var _a = element.getBoundingClientRect(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    return new DOMRect(x / cssScale, y / cssScale, width / cssScale, height / cssScale);
};
exports.getInterfaceRect = getInterfaceRect;
var setInterfaceScale = function (scale) {
    if (scale === cssScale)
        return;
    var collectMediaQueries = function (rules) {
        Array.from(rules).forEach(function (rule) {
            if (rule instanceof CSSMediaRule && !mediaQueries.has(rule)) {
                mediaQueries.set(rule, rule.media.mediaText);
            }
            if ('cssRules' in rule)
                collectMediaQueries(rule.cssRules);
        });
    };
    // The app's extracted styles are same-origin and loaded before React mounts.
    Array.from(document.styleSheets).forEach(function (sheet) {
        if (sheet.href && new URL(sheet.href).origin === location.origin) {
            collectMediaQueries(sheet.cssRules);
        }
    });
    // CSS zoom does not change viewport media queries like native page zoom does.
    mediaQueries.forEach(function (query, rule) {
        rule.media.mediaText = query.replace(/((?:min|max)-(?:width|height):\s*)([\d.]+)px/g, function (_, feature, value) { return "".concat(feature).concat(Number(value) * scale, "px"); });
    });
    cssScale = scale;
    document.documentElement.style.setProperty('--interface-scale', String(scale));
    window.dispatchEvent(new Event('resize'));
};
exports.setInterfaceScale = setInterfaceScale;
